import React, { useState } from "react";
import CodeMirror from "@uiw/react-codemirror";
import { sql } from "@codemirror/lang-sql";
import { githubLight } from "@uiw/codemirror-theme-github";
//import { oneDark } from "@codemirror/theme-one-dark";
import "./SQLEditor.css";

function SQLEditor({ initialValue = "", onChange }) {
  const [code, setCode] = useState(initialValue);

  const handleChange = (value) => {
    setCode(value);
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <div className="sql-editor-container">
      <CodeMirror
        value={code}
        height="200px"
        extensions={[sql()]}
        theme={githubLight}
        // theme={oneDark}
        onChange={handleChange}
        basicSetup={{
          lineNumbers: true,
          highlightActiveLineGutter: true,
          highlightSpecialChars: true,
          foldGutter: true,
          dropCursor: true,
          allowMultipleSelections: true,
          indentOnInput: true,
          bracketMatching: true,
          autocompletion: false,
        }}
      />
    </div>
  );
}

export default SQLEditor;
